import React, {Dispatch, FC, SetStateAction} from 'react';
// import {useAppSelector} from "../../../../../../hooks/redux";
// import {getLanguage} from "../../../../../../store/selectors/appSelector";
import ModalPortal from "../../../../../../Portals/ModalPortal";
import {EnumFog} from "../../../../../Utils/FogContainer/FogContainer";
import styles from './ProfileMenu_Mobile.module.css'
import {Link} from "react-router-dom";
import {IProfileMenu} from "../../../../../../models/IProfileMenu";
import {LanguageSelect} from "../../LanguageSelect/LanguageSelect";


type PropsType = {
    setIsMenuShown: Dispatch<SetStateAction<boolean>>
    isMenuShown: boolean,
    menuData: IProfileMenu[]
}

const ProfileMenu_Mobile: FC<PropsType> = ({isMenuShown, setIsMenuShown, menuData}) => {

    // const language = useAppSelector(getLanguage)

    return (
        <ModalPortal options={{
            setStateModal: setIsMenuShown,
            fogPower: EnumFog.veryStrong,
            statusModal: isMenuShown
        }}>


            <LanguageSelect/>
            <ul className={styles.menuList}>
                {menuData.map(({title, callback, path}, index) => {
                   if (path !== undefined) {
                       return (
                           <li key={`profileMenuMobile_${index}`} className={styles.menuItem}>
                               <Link to={path} onClick={() => {
                                   setIsMenuShown(false)
                               } }>
                                   {title}
                               </Link>
                           </li>
                       )
                   } else {
                       return (
                           <li key={`profileMenuMobile_${index}`} className={styles.menuItem} onClick={callback}>
                                <span className={styles.menuItem_span}>{title}</span>
                           </li>
                       )
                   }

                })}
            </ul>

        </ModalPortal>
    );
};

export default ProfileMenu_Mobile;